// CustomItem component for creating styled Paper elements

import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

// Custom styled paper component
const CustomItem = styled(Paper)(({ theme }) => ({
  // Set background color based on the current theme
  backgroundColor: theme.palette.background.paper,
  // Set text color based on the current theme
  color: theme.palette.text.secondary,
  // Spread the typography properties for body2
  ...theme.typography.body2,
  // Remove default padding
  padding: theme.spacing(0),
  // Center align text content
  textAlign: 'center',
  // Set text color (this seems redundant with the earlier color property)
  color: theme.palette.text.secondary,
  // Use flexbox for layout
  display: 'flex',
  // Stack child elements vertically
  flexDirection: 'column',
}));

// Export the CustomItem component as the default export
export default CustomItem;